import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { WithdrawSuccess } from '@/features/consumer/withdraw-success';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/withdraw/success'
)({
  component: WithdrawSuccessPage,
});

function WithdrawSuccessPage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/my-wallet' })}
        />
        <HeaderDashboard.Title>Withdraw</HeaderDashboard.Title>
      </HeaderDashboard>
      <WithdrawSuccess />
    </div>
  );
}
